import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import responseHandler from "responseHandler";

import {
  getAppraiserCaseIssueTypes,
  getAppraiserCaseIssues,
  updateAppraiserCaseIssues,
} from "requests/caseIssues";
import AppraiserCaseIssueFields from "components/QualityAssurance/Sections/CaseDetails/CaseIssues/Appraiser/AppraiserCaseIssueFields";
import { MSpinner, MCollapsibleCard } from "components/Shared";

const AppraiserCaseIssues = (props) => {
  const mounted = useRef(true);
  const [caseIssueTypes, setCaseIssueTypes] = useState([]);
  const [caseIssues, setCaseIssues] = useState({});
  const [cardExpanded, setCardExpanded] = useState(false);

  const { controlNumber, makeToast } = props;

  useEffect(() => {
    if (!caseIssueTypes.length) {
      getAppraiserCaseIssueTypes(controlNumber, (s) => {
        setCaseIssueTypes(s);
        refreshIssues();
      }, mounted);
    }
    return () => {
      mounted.current = false;
    };
  }, []);

  const refreshIssues = () => {
    getAppraiserCaseIssues(controlNumber, (s) => setCaseIssues(s), mounted);
  };

  const updateIssues = (caseIssues, force) => {
    updateAppraiserCaseIssues({
      controlIdNumber: controlNumber,
      caseIssues: caseIssues,
    }, () => {
      refreshIssues();
      if (!force) {
        makeToast("Case Issues Saved", "success");
      }
    }, mounted);
  };

  if (!caseIssues.caseIssues) {
    return (<MSpinner />);
  }
  return (
    <MCollapsibleCard
      title="Case Issues"
      expanded={cardExpanded}
      onExpandedChange={setCardExpanded}
    >
      <AppraiserCaseIssueFields
        caseIssues={caseIssues.caseIssues}
        caseIssueTypes={caseIssueTypes}
        updateIssues={updateIssues}
        commentDirection={caseIssues.commentDirection}
        makeToast={makeToast}
      />
    </MCollapsibleCard>
  );
};

AppraiserCaseIssues.propTypes = {
  controlNumber: PropTypes.number,
  makeToast: PropTypes.func.isRequired,
};

const mdtp = dispatch => ({
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  }
});

export default connect(null, mdtp)(AppraiserCaseIssues);